<template>
    <v-container>
        <v-row>
            <v-col cols="12" class="d-flex justify-center align-center" style="min-height:70vh; position:relative;">
                <div style="width:100%; display:flex; justify-content:center;">
                    <div id="monitor">
                        <div class="scan" />
                        <div class="screen" />
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <alert :show-alert="showAlert" :message="message" :type="type" />
            <v-col cols="12" class="mx-auto">
                <v-text-field ref="manualInput" v-model="manualScan" :label="$t('form.pasteQr')" clearable @keyup.enter="processManualScan" />
                <v-btn color="primary" class="mt-2" @click="processManualScan">{{ $t('button.process') }}</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import sportClassService from '@/services/sportClass'
    import Alert from '@/components/Alert'

    export default {
        name: 'SportClassAttendanceQRCode',
        components: { Alert },
        data: () => {
            return {
                id: null,
                showAlert: false,
                message: null,
                type: 'success',
                // manual input for QR text
                manualScan: ''
            }
        },
        created() {
        },
        mounted() {
            this.focusManualInput()
        },
        methods: {
            processManualScan() {
                if (!this.manualScan) {
                    this.focusManualInput()
                    return this.setAlert('Please paste QR text first', 'error')
                }
                this.processDecodedString(this.manualScan)
                this.manualScan = ''
                this.$nextTick(() => this.focusManualInput())
            },

            focusManualInput() {
                this.$nextTick(() => {
                    const ref = this.$refs.manualInput
                    if (!ref) return
                    // Vuetify v-text-field exposes focus() method
                    if (typeof ref.focus === 'function') {
                        ref.focus()
                        return
                    }
                    // fallback to DOM input
                    const el = ref.$el ? ref.$el.querySelector('input') : ref
                    if (el && typeof el.focus === 'function') el.focus()
                })
            },
            processDecodedString(decodedString) {
                console.log(decodedString)
                this.showAlert = true
                let params = decodedString.split('=')
                if (params[0] === 'userId' && this.$route.params.type === 'user') {
                    this.id = params[1]
                    this.addUserAttendance()
                } else if (params[0] === 'coachId' && this.$route.params.type === 'coach') {
                    this.id = params[1]
                    this.addCoachAttendance()
                } else {
                    this.setAlert('Scanned QR is not relevant', 'error')
                }
            },
            addUserAttendance() {
                return sportClassService.userAttendance(this.$route.params.sportClassId, this.id).then(() => {
                    this.setAlert('User attendance recorded', 'success')
                }).catch(err => {
                    const msg = err && err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Failed to add user attendance'
                    this.setAlert(msg, 'error')
                    throw err
                })
            },
            addCoachAttendance() {
                return sportClassService.coachAttendance(this.$route.params.sportClassId, this.id).then(() => {
                    this.setAlert('Coach attendance recorded', 'success')
                }).catch(err => {
                    const msg = err && err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Failed to add coach attendance'
                    this.setAlert(msg, 'error')
                    throw err
                })
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 4000)
            }
        }
    }
</script>

<style scoped>

@media only screen and (min-width: 600px){

    #monitor{
        height: 350px;
        width: 350px;
    }

    @-webkit-keyframes scan {
    0%, 100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }
    100% {
        -webkit-transform: translateY(310px);
        transform: translateY(340px);
    }
}

}

@media only screen and (max-width: 600px){

    #monitor{
        height: 250px;
        width: 250px;
    }

    @-webkit-keyframes scan {
    0%, 100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
    }
    100% {
        -webkit-transform: translateY(210px);
        transform: translateY(240px);
    }
}

}

#monitor{
    margin: auto;
    position:relative;
    --b: 5px;   /* thickness of the border */
    --c: #1a2f5a;   /* color of the border */
    --w: 50px;  /* width of border */
    border: var(--b) solid #0000; /* space for the border */
    --_g: #0000 90deg,var(--c) 0;
    --_p: var(--w) var(--w) border-box no-repeat;
    background:
        conic-gradient(from 90deg  at top    var(--b) left  var(--b),var(--_g)) 0    0    / var(--_p),
        conic-gradient(from 180deg at top    var(--b) right var(--b),var(--_g)) 100% 0    / var(--_p),
        conic-gradient(from 0deg   at bottom var(--b) left  var(--b),var(--_g)) 0    100% / var(--_p),
        conic-gradient(from -90deg at bottom var(--b) right var(--b),var(--_g)) 100% 100% / var(--_p);
}

#monitor .scan
{
    width: 90%;
    margin: auto;
    height: 5px;
    background-color:#ae262e;
    z-index:9999;
    -moz-animation: scan 5s infinite;
    -webkit-animation: scan 5s infinite;
    animation: scan 5s infinite;
    -webkit-animation-direction: alternate-reverse;
    box-shadow:0px 0px 30px rgba(255,204,102,.5);
}
</style>
